import { JSX } from "@liebherr/patternlib";
import React, { useRef } from "react";
import { wrapWc } from "wc-react";

type DropOnONLh<T> = {
  [K in keyof T as K extends `onLh${infer I}` ? `lh${I}` : K]: T[K];
};
export type PLImageProps = DropOnONLh<JSX.PatternlibImage>;
export type PLImageExtendedProps = PLImageProps & React.HTMLAttributes<unknown> & React.RefAttributes<unknown>;

const WrappedImage = wrapWc<JSX.PatternlibImage>("patternlib-image");
export const useRefPLImage = () => useRef<HTMLPatternlibImageElement>(null);

const PLImage = React.forwardRef<HTMLPatternlibImageElement, PLImageExtendedProps>((props, ref) => {
  const myRef = useRefPLImage();
  return (
    <WrappedImage ref={ref ?? myRef} {...props}>
      {props.children}
    </WrappedImage>
  );
});
PLImage.displayName = "PLImage";

export default PLImage;
